import axios from "../../../../api/axios";
import { Tag } from "../../../../types/types";

type TagResponseData = {
  items: Tag[];
  total: number;
};

type TagResponse = {
  data: TagResponseData;
  message: string;
};

export const fetchTags = async (): Promise<TagResponseData> => {
  try {
    const response = await axios.get<TagResponse>("/tags?offset=0&limit=100");
    return response.data.data;
  } catch (err) {
    throw new Error(`Failed to fetch tags: ${err}`);
  }
};
